import { Button } from "antd"
import classNames from "classnames"

import styles from "./OutlineButton.module.scss"

function OutlineButton({ ...restProps }) {
  return (
    <Button
      {...restProps}
      className={classNames(styles.button, restProps.className)}
    />
  )
}

export default OutlineButton
